class FfVideoSlider extends HTMLElement {
  constructor(){
    super();
    if (this.querySelector(".ff-video-vimeo-first-slide")) {
      this.videoTagVimeo = this.querySelector(".ff-video-vimeo-first-slide")
    }else if (this.querySelector(".ff-video-youtube-first-slide")) {
      this.videoTagYoutube = this.querySelector(".ff-video-youtube-first-slide")
    }else if (this.querySelector(".ff-video-custom-first-slide")) {
      this.videoTagCustom = this.querySelector(".ff-video-custom-first-slide")
    }
    
    if (this.querySelector(".ff-video-vimeo-second-slide")) {
      this.videoTagVimeoSS = this.querySelector(".ff-video-vimeo-second-slide")
    }else if (this.querySelector(".ff-video-youtube-second-slide")) {
      this.videoTagYoutubeSS = this.querySelector(".ff-video-youtube-second-slide")
    }else if (this.querySelector(".ff-video-custom-second-slide")) {
      this.videoTagCustomSS = this.querySelector(".ff-video-custom-second-slide")
    }
    //this.addEvents();
  }
  addEvents(){
    if (screen.width<1001) {
      if (this.videoTagVimeo && this.dataset.videoUrlFirstSlide) {
        this.videoTagVimeo.src = `https://player.vimeo.com/video/${this.dataset.videoUrlFirstSlide}?autoplay=1&byline=0&controls=${this.dataset.data-video-controls}&loop=1&muted=${this.dataset.data-video-muted}&playsinline=1&title=0`
      }else if (this.videoTagYoutube && this.dataset.videoUrlFirstSlide) {
        this.videoTagYoutube.src = `https://www.youtube.com/embed/${this.dataset.videoUrlFirstSlide}?autoplay=1&mute=${this.dataset.data-video-muted}&loop=1&playlist=${this.dataset.videoUrlFirstSlide}&showinfo=0&controls=${this.dataset.data-video-controls}&rel=0&modestbranding=1`
      }else if (this.videoTagCustom && this.dataset.videoUrlFirstSlideCustom) {
        console.log(this.dataset.videoUrlFirstSlideCustom);
        this.videoTagCustom.src = this.dataset.videoUrlFirstSlideCustom;
      }
      if (this.videoTagVimeoSS && this.dataset.videoUrlSecondSlide) {
        this.videoTagVimeoSS.src = `https://player.vimeo.com/video/${this.dataset.videoUrlSecondSlide}?autoplay=1&byline=0&controls=${this.dataset.data-video-controls}&loop=1&muted=${this.dataset.data-video-muted}&playsinline=1&title=0`
      }else if (this.videoTagYoutubeSS && this.dataset.videoUrlSecondSlide) {
        this.videoTagYoutubeSS.src = `https://www.youtube.com/embed/${this.dataset.videoUrlSecondSlide}?autoplay=1&mute=${this.dataset.data-video-muted}&loop=1&playlist=${this.dataset.videoUrlSecondSlide}&showinfo=0&controls=${this.dataset.data-video-controls}&rel=0&modestbranding=1`
      }else if (this.videoTagCustomSS && this.dataset.videoUrlSecondSlideCustom) {
        this.videoTagCustomSS.src = `https://www.youtube.com/embed/${this.dataset.videoUrlSecondSlideCustom}?autoplay=1&mute=${this.dataset.data-video-muted}&loop=1&playlist=${this.dataset.videoUrlSecondSlide}&showinfo=0&controls=${this.dataset.data-video-controls}&rel=0&modestbranding=1`
      }
    }
  }
}
customElements.define('ff-video-slider', FfVideoSlider);
